import { render } from "./ProductoGrupoEditorModal.vue?vue&type=template&id=981807d2&scoped=true"
import script from "./ProductoGrupoEditorModal.vue?vue&type=script&lang=js"
export * from "./ProductoGrupoEditorModal.vue?vue&type=script&lang=js"

import "./ProductoGrupoEditorModal.vue?vue&type=style&index=0&id=981807d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-981807d2"]])

export default __exports__